export class Persona {
    id: number;
	curp: string;
	nombre: string;
	primerApellido: string;
	segundoApellido: string;
	rfc: string;
	fechaNacimiento: string;
	lugarNacimiento: string;
	observaciones: string;
	usuario: string;
	pass: string;
	tipoPass: number;
	fechaLimite: string;
	estatus: number;
}
